"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'textDefault';
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0];

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return {
    root: {
      height: spacing(size),
      width: spacing(size),
      color: colors[color],
      margin: spacing.apply(void 0, (0, _toConsumableArray2["default"])(margin))
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors }}", function () {
  return [_useTheme2["default"]];
});

var Icon = function Icon(props, ref) {
  var Element = props.as,
      margin = props.margin,
      size = props.size,
      color = props.color,
      other = (0, _objectWithoutProperties2["default"])(props, ["as", "margin", "size", "color"]);
  var classes = useStyles(size, color, margin);

  if (!Element) {
    return null;
  }

  return (0, _core.jsx)(Element, (0, _extends2["default"])({
    ref: ref,
    css: classes.root
  }, other));
};

__signature__(Icon, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(Icon);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
  reactHotLoader.register(Icon, "Icon", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icon/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();